export default __webpack_public_path__ + "static/media/sj.83241487.svg";